//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Assemblies.js";
import "../no/Builder.js";
import "../no/SelectDisplayableObjectList.js";
import "../no/ErrorList.js";
import "../no/ugmath.js";
import "../no/FileNew.js";
import "../no/PDM.js";
import "../no/SelectObjectList.js";
let d=[[[0,"Count",1,0],[0,"DesignElementType",1,0],[1,"DesignElementsToOperate",0,"SelectDisplayableObjectList",0],[0,"EditAction",1,0],[0,"EffectivityTable",0,"PDM.EffectivityTableBuilder",0],[0,"FileNewDescriptor",0,"FileNew",0],[0,"KeepOriginalDesignElement",1,0],[0,"Layer",1,0],[0,"LayerOption",1,0],[0,"OwningSubsetInstance",1,"Assemblies.Subset",0],[0,"PartToUse",1,"BasePart",0],[0,"PositioningOptionValue",1,0],[0,"ReferenceSet",1,0],[0,"ReferenceSetName",1,0],[0,"SaveAsAction",1,0],[0,"Scatter",1,0],[0,"State",1,0]],[[["position","orientation"],"GetPosition",{},0,0],[["position","orientation"],"SetPosition",{},2,0],[["nPartitions","partitions"],"GetAddPartitions",{},0,0],[["partitions"],"AddToPartitions",{},1,0],[["nPartitions","partitions"],"GetRemovePartitions",{},0,0],[["partitions"],"RemoveFromPartitions",{},1,0],[["nObjects","logicalObjects"],"CreateLogicalObjects",{},0,0],[["logicalObjects"],"PartiallyCommit",{},1,0],[[],"GetOperationFailures",{R_:{operationFailures:"ErrorList"}},0,0],[["objects"],"AutoAssignAttributes",{R_:{failedObjectsErrorInfo:"ErrorList"}},1,0],[["objects","properties"],"AutoAssignAttributesWithNamingPattern",{R_:{failedObjectsErrorInfo:"ErrorList"}},2,0],[["attributeTitles","titlePatterns"],"CreateAttributeTitleToNamingPatternMap",{R_:{attributeTitleToNamingPatternMap:"NXObject"}},2,0],[["object","nRevsOpt","revOptions"],"GetItemRevisionNamingRules",{},1,0],[["object","nPatterns","patternList"],"GetItemNamingRulePatterns",{},1,0]],[]];
SPLM.Assemblies.DesignElementBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Assemblies.DesignElementBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Assemblies.DesignElementBuilder.OperationType = Object.freeze({
    "Create" : "Create", "Edit" : "Edit", "SaveAs" : "SaveAs", "Save" : "Save", "SaveAndClose" : "SaveAndClose", "Undefined" : "Undefined"});

SPLM.Assemblies.DesignElementBuilder.EditActionType = Object.freeze({
    "Category" : "Category", "Partitions" : "Partitions", "Effectivity" : "Effectivity"});

SPLM.Assemblies.DesignElementBuilder.SaveAsActionType = Object.freeze({
    "NewRevision" : "NewRevision", "NewDesignElement" : "NewDesignElement"});

SPLM.Assemblies.DesignElementBuilder.StateType = Object.freeze({
    "Shape" : "Shape", "Reuse" : "Reuse", "Promissory" : "Promissory"});

SPLM.Assemblies.DesignElementBuilder.ReferenceSetType = Object.freeze({
    "Model" : "Model", "EntirePart" : "EntirePart", "AsSpecified" : "AsSpecified"});

SPLM.Assemblies.DesignElementBuilder.LayerOptionType = Object.freeze({
    "Original" : "Original", "Work" : "Work", "AsSpecified" : "AsSpecified"});

SPLM.Assemblies.DesignElementBuilder.PositioningOption = Object.freeze({
    "AbsoluteOrigin" : "AbsoluteOrigin", "Maintain" : "Maintain", "AsSpecified" : "AsSpecified"});

export default SPLM;